import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeZone(zone: Boundaries["removeZone"]["request"]): void;
}

function useZoneRemoval(zone: Identifiable<Zone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isZoneRemovalRequestPending(zone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isZoneRemovalRequestSuccess(zone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isZoneRemovalRequestFailure(zone),
    ),
    removeZone: core.removeZone,
  };
}

export { useZoneRemoval };
